import { useClerk } from '@clerk/react-router';
import { useLingui } from '@lingui/react/macro';
import { APP_PATHS } from 'app-shared/constants';
import { Dropdown } from 'app-ui/components';
import { IconLogout } from 'app-ui/icon';

export const ClerkSignOutItem = () => {
  const { t } = useLingui();
  const { signOut } = useClerk();

  const handleSignOutClick = () => {
    void signOut({ redirectUrl: APP_PATHS.signIn });
  };

  return (
    <Dropdown.ActionItem
      startIcon={<IconLogout />}
      onClick={handleSignOutClick}
    >
      {t`Sign out`}
    </Dropdown.ActionItem>
  );
};
